import { render, staticRenderFns } from "./ForumStockContext.vue?vue&type=template&id=1ad11f28&scoped=true&"
import script from "./ForumStockContext.vue?vue&type=script&lang=js&"
export * from "./ForumStockContext.vue?vue&type=script&lang=js&"
import style0 from "./ForumStockContext.vue?vue&type=style&index=0&id=1ad11f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad11f28",
  null
  
)

export default component.exports